import Avatar from '@shared/components/Avatar/Avatar';
import { useTranslation } from 'react-i18next';

import AvatarSetting from 'components/AvatarSetting/AvatarSetting';
import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useMatrixAvatar from 'modules/Authentication/hooks/useMatrixAvatar';
import useMxCookies from 'modules/Authentication/hooks/useMxCookies';

/**
 * Update avatar image for the user
 * @returns The component if user is logged in
 */
const UpdateAvatar = () => {
  const { t } = useTranslation();
  const { mxDisplayName } = useMxCookies();
  const { matrixClient, mxAvatarUrl, setMxAvatarUrl } = useMatrixContext();
  const { changeAvatar, clearAvatar, loading } = useMatrixAvatar(matrixClient, setMxAvatarUrl);

  return (
    <AvatarSetting
      title={t('profile_picture')}
      avatarUrl={mxAvatarUrl}
      fallbackAvatar={<Avatar size="lg" name={mxDisplayName} />}
      onChange={changeAvatar}
      onClear={clearAvatar}
      isLoading={loading}
    />
  );
};

export default UpdateAvatar;
